import { render, staticRenderFns } from "./RenderResponsavelAction.vue?vue&type=template&id=0f87118b"
import script from "./RenderResponsavelAction.vue?vue&type=script&lang=ts"
export * from "./RenderResponsavelAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports